var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2678 2.73223C20.2915 1.75592 18.7085 1.75592 17.7322 2.73223L8.25 12.2145V15.75H11.7855L21.2678 6.26777C22.2441 5.29146 22.2441 3.70854 21.2678 2.73223Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.61929 3.11929 4.5 4.5 4.5H9.5C10.1904 4.5 10.75 5.05964 10.75 5.75C10.75 6.44036 10.1904 7 9.5 7H4.5V19.5H17V14.5C17 13.8096 17.5596 13.25 18.25 13.25C18.9404 13.25 19.5 13.8096 19.5 14.5V19.5C19.5 20.8807 18.3807 22 17 22H4.5C3.11929 22 2 20.8807 2 19.5V7Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackEdit);
export default __webpack_public_path__ + "static/media/black-edit.c130ca758fbeaaf7643d45f1ffb4508d.svg";
export { ForwardRef as ReactComponent };